import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchInvoicesElectricity, fetchInvoicesGas, fetchInvoicesWater } from '../actions/entry';
import {
  settingPriceSelector,
  deviceByIdSelector,
  currentUserSelector,
  isAdminSelector,
  isManagerSelector,
  itemsSelector,
} from '../selectors';
import Invoices from '../components/Invoices';

const mapStateToProps = (state) => {
  const isAdmin = isAdminSelector(state);
  const isManager = isManagerSelector(state);

  let { electricity, water, gas } = state.invoices;
  const settingPrice = settingPriceSelector(state);
  const { organization } = currentUserSelector(state);
  const items = itemsSelector(state);

  electricity = electricity.map((invoice) => {
    const device = deviceByIdSelector(state, invoice.id);
    const item = items.find((it) => it.itemName === invoice.itemName);
    if (device.logicDevice) {
      const energyBegin = electricity.reduce((sumEnergyBegin, it) => {
        if (device.deviceIds.includes(it.id)) {
          return sumEnergyBegin + it.energyBegin * 1;
        }
        return sumEnergyBegin;
      }, 0);

      const energyEnd = electricity.reduce((sumEnergyEnd, it) => {
        if (device.deviceIds.includes(it.id)) {
          return sumEnergyEnd + it.energyEnd * 1;
        }
        return sumEnergyEnd;
      }, 0);

      return {
        ...invoice,
        energyBegin,
        energyEnd,
        device,
        item,
        organization: organization || 'Sei-Power',
        position: device.position,
      };
    }
    return {
      ...invoice,
      device,
      item,
      organization: organization || 'Sei-Power',
      position: device.position,
    };
  });

  water = water.map((invoice) => {
    const device = deviceByIdSelector(state, invoice.id);
    const item = items.find((it) => it.itemName === invoice.itemName);
    if (device.logicDevice) {
      const energyBegin = electricity.reduce((sumEnergyBegin, it) => {
        if (device.deviceIds.includes(it.id)) {
          return sumEnergyBegin + it.energyBegin * 1;
        }
        return sumEnergyBegin;
      }, 0);

      const energyEnd = electricity.reduce((sumEnergyEnd, it) => {
        if (device.deviceIds.includes(it.id)) {
          return sumEnergyEnd + it.energyEnd * 1;
        }
        return sumEnergyEnd;
      }, 0);

      return {
        ...invoice,
        energyBegin,
        energyEnd,
        device,
        item,
        organization: organization || 'Sei-Power',
        position: device.position,
      };
    }
    return {
      ...invoice,
      device,
      item,
      organization: organization || 'Sei-Power',
      position: device.position,
    };
  });

  gas = gas.map((invoice) => {
    const device = deviceByIdSelector(state, invoice.id);
    const item = items.find((it) => it.itemName === invoice.itemName);
    if (device.logicDevice) {
      const energyBegin = electricity.reduce((sumEnergyBegin, it) => {
        if (device.deviceIds.includes(it.id)) {
          return sumEnergyBegin + it.energyBegin * 1;
        }
        return sumEnergyBegin;
      }, 0);

      const energyEnd = electricity.reduce((sumEnergyEnd, it) => {
        if (device.deviceIds.includes(it.id)) {
          return sumEnergyEnd + it.energyEnd * 1;
        }
        return sumEnergyEnd;
      }, 0);

      return {
        ...invoice,
        energyBegin,
        energyEnd,
        device,
        item,
        organization: organization || 'Sei-Power',
        position: device.position,
      };
    }
    return {
      ...invoice,
      device,
      item,
      organization: organization || 'Sei-Power',
      position: device.position,
    };
  });

  return {
    settingPrice,
    electricity: electricity.sort((a, b) => a.device.order - b.device.order),
    water: water.sort((a, b) => a.device.order - b.device.order),
    gas: gas.sort((a, b) => a.device.order - b.device.order),
    isEditable: isAdmin || isManager,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchInvoicesElectricity: fetchInvoicesElectricity,
      onFetchInvoicesGas: fetchInvoicesGas,
      onFetchInvoicesWater: fetchInvoicesWater,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Invoices);
